export default (hierarchy, { cIndex, sIndex, pIndex }) => {
    let nominee = { cIndex, sIndex, pIndex };

    if (cIndex > -1 && sIndex > -1 && pIndex > -1) {
        --nominee.pIndex;
    }

    if (cIndex > -1 && sIndex > -1 && pIndex < 0) {
        --nominee.sIndex;
    }

    /**Index Change */
    if (cIndex > -1 && sIndex < 0 && pIndex < 0) {
        --nominee.cIndex;
    }

    if (nominee.cIndex > -1 && nominee.sIndex > -1 && nominee.pIndex > -1) {
        return hierarchy[nominee.cIndex].children[nominee.sIndex].children[nominee.pIndex];
    }

    if (nominee.cIndex > -1 && nominee.sIndex > -1 && nominee.pIndex < 0) {
        return hierarchy[nominee.cIndex].children[nominee.sIndex];
    }

    if (nominee.cIndex > -1 && nominee.sIndex < 0 && nominee.pIndex < 0) {
        return hierarchy[nominee.cIndex];
    }
};